import { render, staticRenderFns } from "./idolGoodsOrderList.vue?vue&type=template&id=6a84ae97&scoped=true"
import script from "./idolGoodsOrderList.vue?vue&type=script&lang=ts"
export * from "./idolGoodsOrderList.vue?vue&type=script&lang=ts"
import style0 from "./idolGoodsOrderList.vue?vue&type=style&index=0&id=6a84ae97&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a84ae97",
  null
  
)

export default component.exports